import { render, staticRenderFns } from "./zhihuijiaoyu.vue?vue&type=template&id=3e394552&scoped=true&"
import script from "./zhihuijiaoyu.vue?vue&type=script&lang=js&"
export * from "./zhihuijiaoyu.vue?vue&type=script&lang=js&"
import style0 from "./zhihuijiaoyu.vue?vue&type=style&index=0&id=3e394552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e394552",
  null
  
)

export default component.exports